module.exports = __webpack_public_path__ + "media/icons/cloud-upload-5e90b0a5.svg";